'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fbemitter = require('fbemitter');

var _ = require('../../');

require('./toast.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeckoToast = function (_Component) {
    _inherits(GeckoToast, _Component);

    function GeckoToast(props) {
        _classCallCheck(this, GeckoToast);

        var _this = _possibleConstructorReturn(this, (GeckoToast.__proto__ || Object.getPrototypeOf(GeckoToast)).call(this, props));

        _this.state = {
            items: _.GeckoToastService.items
        };


        if (!_.GeckoToastService.emitter) _.GeckoToastService.emitter = new _fbemitter.EventEmitter();

        _.GeckoToastService.emitter.addListener('update', function () {
            var items = _.GeckoToastService.items;
            _this.setState({ items: items });
        });
        return _this;
    }

    _createClass(GeckoToast, [{
        key: 'removeToast',
        value: function removeToast(toast) {
            return new _.GeckoToastService().remove(toast);
        }
    }, {
        key: 'renderIcon',
        value: function renderIcon(type) {
            return _.GECKO_CONSTS.TOAST_STYLES[type].icon;
        }
    }, {
        key: 'renderClasses',
        value: function renderClasses(type) {
            return _.GECKO_CONSTS.TOAST_STYLES[type].class;
        }
    }, {
        key: 'renderToast',
        value: function renderToast(toast, i) {
            return _react2.default.createElement(
                'div',
                { className: this.renderClasses(toast.type), key: i, onClick: this.removeToast.bind(this, toast) },
                _react2.default.createElement(_.GeckoIcon, { icon: this.renderIcon(toast.type) }),
                _react2.default.createElement(
                    'span',
                    { className: 'message' },
                    toast.message
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.state.items.length) {
                return _react2.default.createElement(
                    'div',
                    { role: 'alert', 'aria-live': 'assertive', className: 'gecko-ui-toasts' },
                    this.state.items.map(function (toast, i) {
                        return _this2.renderToast(toast, i);
                    })
                );
            }
            return null;
        }
    }]);

    return GeckoToast;
}(_react.Component);

exports.default = GeckoToast;